import { ElementRef, NgZone, Optional } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { tuiZoneOptimized, watch } from '@taiga-ui/cdk';
import { TUI_IS_MOBILE_RES, TUI_MEDIA, TUI_MODE } from '@taiga-ui/core/tokens';
import { fromEvent, EMPTY } from 'rxjs';
import { startWith, map, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { TuiModeDirective } from '@taiga-ui/core/directives/mode';

function isMobileResFactory(windowRef, { mobile }, { nativeElement }, ngZone) {
    const mobile$ = fromEvent(windowRef, 'resize').pipe(startWith(null), map(() => windowRef.innerWidth < mobile), distinctUntilChanged(), tuiZoneOptimized(ngZone));
    nativeElement['$.class._mobile'] = mobile$;
    return mobile$;
}
const TUI_IS_MOBILE_RES_PROVIDER = {
    provide: TUI_IS_MOBILE_RES,
    deps: [WINDOW, TUI_MEDIA, ElementRef, NgZone],
    useFactory: isMobileResFactory,
};

function modeFactory(mode, { nativeElement }) {
    const mode$ = mode
        ? mode.change$.pipe(startWith(null), map(() => mode.mode))
        : EMPTY;
    nativeElement['$.data-mode.attr'] = mode$;
    return mode$;
}
const MODE_PROVIDER = {
    provide: TUI_MODE,
    deps: [[new Optional(), TuiModeDirective], ElementRef],
    useFactory: modeFactory,
};

function watchedControllerFactory(controller, changeDetectorRef, destroy$) {
    controller.change$.pipe(watch(changeDetectorRef), takeUntil(destroy$)).subscribe();
    return controller;
}

/**
 * Generated bundle index. Do not edit.
 */

export { MODE_PROVIDER, TUI_IS_MOBILE_RES_PROVIDER, isMobileResFactory, modeFactory, watchedControllerFactory };

//# sourceMappingURL=taiga-ui-core-providers.js.map